import React, { Component } from "react";
import disengagedType from "./types/disengagedType";
import {
  Wrapper,
  Header,
  HeaderText,
  ToggleView,
  AgentWrapper,
  AgentDetails,
  Avatar,
  AvatarImage,
  TextDetails,
  Name,
  NameLink,
  Company,
  ActiveSince,
  Actions,
  StarRating,
  StarRatingLabel,
  FillRating,
  EmptyRating,
  Stars,
  NoRatings,
  HHScore,
  Score,
} from "./styles/disengaged-styles";

import { NewBadge, NewBadgeWrapper } from "./styles/new-badge-styles";

class Disengaged extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isExpanded: true,
    };
  }

  handleToggleView = () => {
    const { isExpanded } = this.state;
    this.setState({
      isExpanded: !isExpanded,
    });
  };

  render() {
    const { agents } = this.props;
    const { isExpanded } = this.state;

    return (
      <Wrapper className={isExpanded && "is-expanded"}>
        <Header className={isExpanded && "is-expanded"}>
          <HeaderText>Rejected/Disengaged</HeaderText>
          <ToggleView onClick={this.handleToggleView}>
            {isExpanded ? "hide all" : "show all"}
          </ToggleView>
        </Header>
        {agents.map((agent) => (
          <AgentWrapper key={agent.id}>
            <AgentDetails>
              <Avatar>
                <AvatarImage src={agent.avatar} alt="Avatar" />
              </Avatar>
              <TextDetails>
                <Name psl={agent.psl}>
                  <NameLink
                    href={agent.agentUrl}
                    title={agent.name}
                    data-turbolinks="false"
                  >
                    {agent.name}
                  </NameLink>
                </Name>
                <Company>{agent.company}</Company>
                <ActiveSince>Active since: {agent.activeSince}</ActiveSince>
                <HHScore>
                  HH Score:{" "}
                  {agent.isNew ? (
                    "no score yet"
                  ) : (
                    <Score>{agent.hhScore}/10</Score>
                  )}
                </HHScore>
                {agent.isNew && (
                  <NewBadgeWrapper>
                    <NewBadge>NEW!</NewBadge>
                  </NewBadgeWrapper>
                )}
                {agent.starRatingPercent ? (
                  <StarRating className="star-ratings">
                    <StarRatingLabel>Reviews:</StarRatingLabel>
                    <FillRating
                      className="fill-ratings"
                      style={{ width: `${agent.starRatingPercent}%` }}
                    >
                      <Stars>★★★★★</Stars>
                    </FillRating>
                    <EmptyRating className="empty-ratings">
                      <Stars>★★★★★</Stars>
                    </EmptyRating>
                  </StarRating>
                ) : (
                  <NoRatings>no ratings yet</NoRatings>
                )}
              </TextDetails>
            </AgentDetails>
            <Actions />
          </AgentWrapper>
        ))}
      </Wrapper>
    );
  }
}

Disengaged.propTypes = {
  agents: disengagedType.isRequired,
};

export default Disengaged;
